module.exports = __webpack_public_path__ + "static/bee-12a55fbf4bb2e43edf829e5e9adc4964.gif";